/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 7.71 12.73',
    data: '<g data-name="Layer 2"><g data-name="Layer 1" _fill="#fff"><path pid="0" d="M1.35 5l6.36 6.36-1.35 1.37L0 6.36z"/><path pid="1" d="M0 6.36L6.36 0l1.35 1.35-6.36 6.36z"/></g></g>'
  }
})
